import { Items } from './items';

export class Order{

    key: string;
    name: string;
    address: string;
    state: string;
    pincode: string;
    items: Items[];
    status: string;
    email: String;
    phone: string;
    createdDate: Date;
    updatedDate: Date;
    receiptDetails: ReceiptDetails;
    schoolDetails: schoolDetails;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}

export class ReceiptDetails{
    receiptUrl: string;
    fileName: string;
    fileType: string;
}

export class schoolDetails{
    schoolName: string;
    schoolCertUrl: string;
    certFileName: string;
    certFileType: string;
}